import gql from "graphql-tag";

import type {ApolloGqlClient, ApolloResult} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

export type UserRole = "TEACHER" | "PARENT";
export type UserHomepage = "COACH" | "PARENT" | "LEARNER" | "DISTRICT_ADMIN";

type UpdateRolesData = {
    updateRolesAndHomepageSettings?: {
        error:
            | {
                  code: string;
              }
            | null
            | undefined;
    };
};

type UpdateRolesVariables = {
    roles: ReadonlyArray<UserRole>;
    homepage: UserHomepage;
};

const UPDATE_ROLES_AND_HOMEPAGE_MUTATION: GqlOperation<
    UpdateRolesData,
    UpdateRolesVariables
> = gqlOp(gql`
    mutation UpdateRolesAndHomepage(
        $roles: [UserRole]!
        $homepage: UserHomepage!
    ) {
        updateRolesAndHomepageSettings(roles: $roles, homepage: $homepage) {
            user {
                id
                isTeacher
                isParent
                homepageUrl
            }
            error {
                code
            }
        }
    }
`);

export const updateRolesAndHomepage = (
    gqlClient: ApolloGqlClient,
    roles: Array<UserRole>,
    homepage: UserHomepage,
): Promise<ApolloResult<UpdateRolesData>> => {
    return gqlClient
        .mutate(UPDATE_ROLES_AND_HOMEPAGE_MUTATION, {
            variables: {
                roles,
                homepage,
            },
        })
        .then((r) => {
            if (r.data?.updateRolesAndHomepageSettings?.error) {
                throw new KAError(
                    r.data.updateRolesAndHomepageSettings.error.code,
                    Errors.Internal,
                );
            }

            return r;
        })
        .catch((e) => {
            throw new KAError(
                "Failed to update roles and homepage",
                Errors.Internal,
                {cause: e},
            );
        });
};
